/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */

export enum ENotificationPlace {
    accountId = 'accountId',
    global = 'global',
    subscriberId = 'subscriberId',
}

export enum ENotificationLevelTypes {
    DANGER = 'ERROR',
    ERROR = 'ERROR',
    INFO = 'INFO',
    SUCCESS = 'SUCCESS',
    WARN = 'WARN',
}

export enum ENotificationTypes {
    AUTH = 'AUTH',
    AUTH_SERVICE_ACCESS = 'AUTH_SERVICE_ACCESS',
    UNPAID_BILLS = 'UNPAID_BILLS',
    OUTSTANDING_DEBT = 'OUTSTANDING_DEBT',
}

export interface INotification {
    level: ENotificationLevelTypes;
    message: string;
    type?: ENotificationTypes;
    urls?: Array<{
        label: string;
        tooltip?: string;
        url: string;
    }>;
}
